import {translateService} from "../../services/TranslateService";
import styles from "./VehicleSearch.module.scss";
import Modal from "react-modal";
import * as React from "react";
import {useContext, useState} from "react";
import {DataContext} from "../../contexts/dataContext";
import {IVehicleSearch} from "../../interfaces/VehicleSearch";
import {useSelector} from "react-redux";
import {GlobalStore} from "../../reduxStore";
import { CircularProgress } from '@mui/material';

const modalPopupStyle = {
    content: {
        width: 'auto',
        minWidth: '200px',
        maxWidth: '769px',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgba(0,0,0,0.7)',
        color: 'white',
        textAlign: 'center',
    },
    overlay: {
        zIndex: '1',
    },
};

interface VipCodeVehiclesProps {
    isVipVehicle: boolean,
    setVipCodeValid: Function,
    vehicle: IVehicleSearch,
    selectVehicle: Function,
    vipCodeCheckOpen: boolean,
    setVipCodeCheckOpen: Function,
    discount?: null | number,
}

export const VipCodeVehicles = ({isVipVehicle, setVipCodeValid, vehicle,
                                    selectVehicle, vipCodeCheckOpen, setVipCodeCheckOpen, discount}: VipCodeVehiclesProps) => {
    const dataContext = useContext(DataContext);
    const apiService = useSelector((state: GlobalStore) => state.chauffeurReducer.apiService);
    const [vipCode, setVipCode] = useState<string>('');
    const [vipCodeError, setVipCodeError] = useState<string>('');
    const [busyValidating, setBusyValidating] = useState(false);

    const validateVipCode = (code: string) => {
        setTimeout(() => {
            // timeout ensure busy state updates to show that api call was initialised (it is usually very quick for this api res)
            try{
                apiService?.vehicle.searchWithParams({...dataContext.searchParameters, carId: vehicle.id, discount: code}).then((res) => {
                    if(res.count === 1 && res.vehicles[0]?.privateData?.private === false) {
                        setVipCodeError('');
                        setVipCodeValid(true);
                        dataContext.changeValidatedVipVehicles(vehicle.id);
                        discount = 0;
                        setVipCodeCheckOpen(false);
                        selectVehicle(vehicle); // select vehicle if code is valid
                        !dataContext.oneWayRes ? dataContext.sendGaEvent('reservation','beginReservation', '', 0) :
                            dataContext.sendGaEvent('reservation','beginOneWayReservation',  '', 0);
                    } else {
                        setVipCodeError(translateService.translate('vehicleSearch1.invalidCode'));
                    }
                }).finally(() => {
                    setBusyValidating(false);
                })
            }
            catch (e) {
                setVipCodeError(translateService.translate('vehicleSearch.errorLoadingResults'));
                setBusyValidating(false);
                console.log(e);
            }
        }, 200)
    }

    return (
        <div> {
            isVipVehicle ? <Modal style={Object.assign(modalPopupStyle)} isOpen={vipCodeCheckOpen}>
                    {busyValidating ?
                        <div className="d-flex justify-content-center my-2 pb-3 pt-2">
                            <CircularProgress color={"warning"}/>
                        </div>
                        :
                        <div>
                            <div className='icon-top-heading text-dark'>
                                {translateService.translate('vehicleSearch1.enterVipCode')}
                            </div>
                            <hr />
                            <input className={styles.vipCodeInput} type={"text"} value={vipCode}
                                   onChange={(e) => {setVipCode(e.target.value);
                                       if(vipCodeError) { setVipCodeError('')}}}/>
                            <div className={styles.vipCodeError} > {vipCodeError.length ? <span> {vipCodeError} </span> : null} </div>
                            <div className={styles.vipModalButtons}>
                                <button onClick={() => {setVipCode(''); setVipCodeError(''); setVipCodeCheckOpen(false)}}
                                        className='btn btn-primary btn-block mt-2' style={{marginRight: 10}}>{translateService.translate('vehicleSearch1.cancel')}</button>
                                <button onClick={() => {vipCode.length < 5 || vipCode.length > 15 ? setVipCodeError(translateService.translate('vehicleSearch1.invalidCode')) :
                                    setBusyValidating(true); validateVipCode(vipCode);}} className='btn btn-primary btn-block mt-2'>{translateService.translate('vehicleSearch1.send')}</button>
                            </div>
                        </div>
                    }
                </Modal>
                : null }
        </div>
    )
};


interface VipCodeFromMapProps {
    vehicle?: IVehicleSearch,
    selectVehicle: Function, vipCodeCheckOpen: boolean,
    setVipCodeCheckOpen: Function,
    discount?: null | number,
    clearSelectedVehicle: Function
}

// opening Vip Code Modal through map card is used slight differently hence it has a separated component
export const VipCodeFromMap = ({vehicle, selectVehicle, vipCodeCheckOpen, setVipCodeCheckOpen, discount, clearSelectedVehicle}: VipCodeFromMapProps) => {
    const dataContext = useContext(DataContext);
    const apiService = useSelector((state: GlobalStore) => state.chauffeurReducer.apiService);
    const [vipCode, setVipCode] = useState<string>('');
    const [vipCodeError, setVipCodeError] = useState<string>('');
    const [busyValidating, setBusyValidating] = useState(false);

    const validateVipCode = (code: string) => {
        setTimeout(() => {
            try{
                apiService?.vehicle.searchWithParams({...dataContext.searchParameters, carId: vehicle?.id, discount: code}).then((res) => {
                    if(res.count === 1 && res.vehicles[0]?.privateData?.private === false) {
                        setVipCodeError('');
                        dataContext.changeValidatedVipVehicles(vehicle?.id);
                        discount = 0;
                        setVipCodeCheckOpen(false);
                        clearSelectedVehicle(undefined);
                        selectVehicle(vehicle); // select vehicle if code is valid
                        !dataContext.oneWayRes ? dataContext.sendGaEvent('reservation','beginReservation', vehicle?.id, 0) :
                            dataContext.sendGaEvent('reservation','beginOneWayReservation', '', 0);
                    } else {
                        setVipCodeError(translateService.translate('vehicleSearch1.invalidCode'));
                    }
                }).finally(() => {
                    setBusyValidating(false);
                })
            } catch (e) {
                setVipCodeError(translateService.translate('vehicleSearch.errorLoadingResults'));
                setBusyValidating(false);
                console.log(e);
            }
        }, 200)
    }

    return (
        <div>
            {vehicle ?
                <Modal style={Object.assign(modalPopupStyle)} isOpen={vipCodeCheckOpen}>
                    { busyValidating ?
                        <div className="d-flex justify-content-center my-2 pb-3 pt-2">
                            <CircularProgress color={"warning"}/>
                        </div>
                        :
                        <div>
                            <div className='icon-top-heading text-dark'>
                                {translateService.translate('vehicleSearch1.enterVipCode')}
                            </div>
                            <hr />
                            <input className={styles.vipCodeInput} type={"text"} value={vipCode}
                                   onChange={(e) => {setVipCode(e.target.value);
                                       if(vipCodeError) { setVipCodeError('')}}}/>
                            <div className={styles.vipCodeError} > {vipCodeError.length ? <span> {vipCodeError} </span> : null} </div>
                            <div className={styles.vipModalButtons}>
                                <button onClick={() => {setVipCode(''); setVipCodeError(''); setVipCodeCheckOpen(false); clearSelectedVehicle(undefined)}}
                                        className='btn btn-primary btn-block mt-2' style={{marginRight: 10}}>{translateService.translate('vehicleSearch1.cancel')}</button>
                                <button onClick={() => {vipCode.length < 5 || vipCode.length > 15 ? setVipCodeError(translateService.translate('vehicleSearch1.invalidCode')) :
                                    setBusyValidating(true); validateVipCode(vipCode)}} className='btn btn-primary btn-block mt-2'>{translateService.translate('vehicleSearch1.send')}</button>
                            </div>
                        </div> }
                </Modal>
                : null
            }
        </div>

    )
};

export function checkVipCodeValid(vehicleId: number, vip: boolean | undefined, validatedVipVehicles: string | undefined) {
    if(vip && validatedVipVehicles && validatedVipVehicles.length) {
        if (validatedVipVehicles.split(',').includes(vehicleId.toString())){
            return true;
        }
        return false;
    }
    return false;
}

// note: this file can be condensed a bit in future some of the similar code pieced shared between components -- but will require some time to change around #todo
